import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { Loading } from "@/layouts/loading";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(inventory)/branch/_layout/accounts/")({
  component: Component,
  loader: async (params) => {

    const currentWeekRevenue = await pharmacyClient.accountsRevenue({
      startDate: Math.floor(Date.now() / 1000) - 604800,
      endDate: Math.floor(Date.now() / 1000),
      calculateMovingAverage: false,
      movingAveragePeriod: 0,
    })

    const lastWeekRevenue = await pharmacyClient.accountsRevenue({
      startDate: Math.floor(Date.now() / 1000) - 1209600,
      endDate: Math.floor(Date.now() / 1000) - 604800,
      calculateMovingAverage: false,
      movingAveragePeriod: 0,
    })

    const currentWeekCogs = await pharmacyClient.accountsCogs({
      startDate: Math.floor(Date.now() / 1000) - 604800,
      endDate: Math.floor(Date.now() / 1000),
      calculateMovingAverage: false,
      movingAveragePeriod: 0,
    })

    const lastWeekCogs = await pharmacyClient.accountsCogs({
      startDate: Math.floor(Date.now() / 1000) - 1209600,
      endDate: Math.floor(Date.now() / 1000) - 604800,
      calculateMovingAverage: false,
      movingAveragePeriod: 0,
    })

    const currentWeekPl = await pharmacyClient.accountsPL({
      startDate: Math.floor(Date.now() / 1000) - 604800,
      endDate: Math.floor(Date.now() / 1000),
      calculateMovingAverage: false,
      movingAveragePeriod: 0,
    })

    const lastWeekPl = await pharmacyClient.accountsPL({
      startDate: Math.floor(Date.now() / 1000) - 1209600,
      endDate: Math.floor(Date.now() / 1000) - 604800,
      calculateMovingAverage: false,
      movingAveragePeriod: 0,
    })

    const currentWeekPaymentMethodBreakdown = await pharmacyClient.accountsPaymentMethodBreakdown({
      startDate: Math.floor(Date.now() / 1000) - 604800,
      endDate: Math.floor(Date.now() / 1000),
    })

    const lastWeekPaymentMethodBreakdown = await pharmacyClient.accountsPaymentMethodBreakdown({
      startDate: Math.floor(Date.now() / 1000) - 1209600,
      endDate: Math.floor(Date.now() / 1000) - 604800,
    })

    return {
      currentWeekCogs,
      lastWeekCogs,
      currentWeekRevenue,
      lastWeekRevenue,
      currentWeekPl,
      lastWeekPl,
      currentWeekPaymentMethodBreakdown,
      lastWeekPaymentMethodBreakdown
    };

  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1
});